module.exports = __webpack_public_path__ + "img/cert-cover.4e5dab5.webp";